import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { Certification } from '../../models/item/item-master/item-master';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class CertificationProxyService {
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/certification';

  private readonly httpClient = inject(HttpClient);

  public getAllCertifications(): Observable<ApiResponse<Certification[]>> {
    return this.httpClient.get<ApiResponse<Certification[]>>(`${this.baseUrl}/all`);
  }
}
